<p-confirmDialog
  key="lockDataDialog"
  #cd
  styleClass="w-9"
  appendTo="body"
  [blockScroll]="false">
  <ng-template pTemplate="headless" let-message>
    <div class="p-card border-round pt-1 p-4">
      <app-header icon="fas fa-house-user" [text]="message.header"></app-header>

      <p class="py-4">
        Die Daten sind im öffentlichen Atlas nicht mehr sichtbar und können nur
        von internen Nutzern gesehen werden.
      </p>
      <!--TODO: Check Bookmarks... mechanism...-->
      <p>
        <strong>Wichtig:</strong> Überprüfen Sie unbedingt, ob die Daten in
        öffentlichen Ansichten genutzt werden! Sollte das der Fall sein, sollten
        Sie die Ansicht ebenfalls intern schalten, da dieses öffentlich nicht
        mehr korrekt dargestellt werden kann. Rufen Sie dazu die
        Ansichten-Übersicht ( <i class="fas fa-note-sticky"></i> ) über die
        Menüleiste links auf.
      </p>
      <div class="flex align-items-center gap-3 mt-4">
        <button
          [rounded]="true"
          [outlined]="true"
          severity="secondary"
          pButton
          icon="fas fa-times"
          label="nein, abbrechen"
          (click)="cd.reject()"></button>
        <button
          [rounded]="true"
          pButton
          icon="fas fa-check"
          label="intern schalten"
          (click)="cd.accept()"
          class="ml-auto"></button>
      </div>
    </div>
  </ng-template>
</p-confirmDialog>
